// extracted by mini-css-extract-plugin
module.exports = {"tag--disabled":"tag_tag--disabled__GKMHq","tag--error":"tag_tag--error__p4p4J"};